<div class="container-fluid bg-white vh-100 p-0">
  <!-- Client Logo Component -->
  <ClientLogo v-if="this.$route.name != 'behalf_application'" />

  <!-- Breadcrumb Component -->
  <BreadCrumb label="Enterprise Anti Money Laundering" />

  <!-- Form Container -->
  <div>
    <div class="d-flex justify-content-center align-items-center min-vh-50">
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <!-- Error Message Display -->
        <div v-if="error" class="alert alert-danger text-center">
          {{ error }}
        </div>

        <!-- Enterprise AML Verification Form -->
        <form @submit.prevent="enterprise_anti_money_laundering_api">
          <!-- First Name Field -->
          <div class="form-group mt-3">
            <label for="enterprisetName" class="fw-bold text-xs text-start d-block">
              Enterprise Name <span class="text-danger">*</span>
            </label>
            <input
              v-model="enterprise_name"
              type="text"
              class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
              id="enterprisetName"
              placeholder="e.g., Dynamic Solutions"
              @input="validate_enterprise_name"
              required
              :disabled="isFieldDisabled.enterprise_name"
            />
            <small v-if="error_messages.enterprise_name" class="form-text text-danger">
              {{ error_messages.enterprise_name }}
            </small>
          </div>

          <!-- Submit Button -->
          <div class="text-center mb-3 mt-4">
            <button
              type="submit"
              class="btn bg-green btn-sm px-4 rounded-small shadow-sm fw-bold secondary-text-dark text-xs"
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>